import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import {
  getCustomTextStyle,
  textStylesConfig,
} from '@styles/vars/textStyles.style'
import styled from 'styled-components'

export const BrandMain = styled.section`
color: ${props => props.color};
background-color: ${props => props.background};

`

export const BrandWrapper = styled.div``

export const BrandHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const BrandTitle = styled.h2`
  ${getCustomTextStyle(textStylesConfig.heading4Sans, textStylesConfig.caption)}
`

export const BrandNav = styled.ul`
  display: flex;
  list-style: none;

  ${mq.tabletPMax} {
    display: none;
  }
  button {
    > div {
      background: ${props => props.backgroundColor} !important;
      color: ${props => props.fontColor} !important;
      border: 1px solid ${props => props.fontColor} !important;
      border-radius: 7rem;
    }
    &:not(:disabled):hover > div {
      background: ${props => props.fontColor} !important;
      color: ${props => props.backgroundColor} !important;
      border: 1px solid ${props => props.fontColor}  !important;
    }

    &:disabled > div {
      opacity: 0.5;
    }
  }
`

export const BrandNavItem = styled.li`
  & + & {
    margin-left: 1rem;
  }
`

export const BrandCarousel = styled.div`
  display: flex;
  width: fit-content;
  ${clamp('margin-top', 30, 90)};
  transform: ${props => props.centered ? 'unset !important' : ''};
  justify-content: ${props => props.centered ? 'center' : ''};
  min-width: ${props => props.centered ? '100%' : ''};
`

export const BrandCardWrapper = styled.div`
&:not(:first-child) {
  ${clamp('padding-left', 15, 36)}
}
`

export const BrandCard = styled.div`
  display: flex;
  flex-direction: column;
  ${clamp('width', 140, 216)}
`

export const BrandCardThumbnail = styled.div`
`

export const BrandCardContent = styled.div`
  margin-top: 20px;
`

export const BrandRole = styled.div`
  font-size: 14px;
`

export const BrandCardLink = styled.a`
  display: inline-flex;
  align-items: flex-start;
  text-decoration: none;

  svg {
    margin-left: 10px;
    width: 26px;
    margin-top: 2px;
  }

  p {
    ${clamp('margin-right', 8, 10)}
  }
`
